import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getMovieBookingRole, isAdminRole } from './movieBookingRole';
import { movieBookingApi } from '../../services/movieBookingApi';
import './MovieBooking.css';

const AdminTheatreForm = () => {
  const { user } = useAuth();
  const isAdmin = isAdminRole(user) || getMovieBookingRole() === 'ADMIN';
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  if (!isAdmin) {
    return (
      <div className="movie-booking-page">
        <h1 className="movie-booking-title">Admin access required</h1>
        <p className="movie-booking-note">Switch to Admin role to manage theatres.</p>
      </div>
    );
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage('');
    try {
      const response = await movieBookingApi.createTheatre({ name, city });
      setMessage(`Theatre created: ${response.data?.id}`);
      setName('');
      setCity('');
    } catch (error) {
      const status = error.response?.status;
      const detail =
        error.response?.data?.message
        || error.response?.data?.error
        || (typeof error.response?.data === 'string' ? error.response.data : null)
        || error.message;
      setMessage(
        status
          ? `Failed to create theatre (HTTP ${status}). ${detail || ''}`.trim()
          : `Failed to create theatre. ${detail || 'Check network and API URL (REACT_APP_API_URL).'}`,
      );
    }
  };

  return (
    <div className="movie-booking-page">
      <div className="movie-booking-header">
        <h1 className="movie-booking-title">Create Theatre</h1>
        <button className="movie-booking-button secondary" onClick={() => navigate('/movies/admin')}>
          Back
        </button>
      </div>

      <form className="movie-booking-form" onSubmit={handleSubmit}>
        <input
          className="movie-booking-input"
          placeholder="Theatre Name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          required
        />
        <input
          className="movie-booking-input"
          placeholder="City"
          value={city}
          onChange={(event) => setCity(event.target.value)}
          required
        />
        <button className="movie-booking-button" type="submit">Create</button>
      </form>
      {message && <p className="movie-booking-note">{message}</p>}
    </div>
  );
};

export default AdminTheatreForm;
